
























import VueOptions from '@utils/VueOptions'
import WizardNavbar from '@ui/SpaceWizards/SamplingSpaceWizard/WizardNavbar'
import WizardNavigation from '@ui/SpaceWizards/SamplingSpaceWizard/WizardNavigation'
import SpaceCard from '@ui/cards/SpaceCard'
import SpaceDisplay from '@ui/Space/SpaceDisplay'

settings =
  name: 'PreviewStep'

  vue:
    props: ['wizard', 'step']

    components: {
      WizardNavbar,
      WizardNavigation,
      SpaceCard,
      SpaceDisplay,
    }

    computed:
      space: ->
        @wizard.spaceData

      optionsForSpaceDisplay: ->
        supplierId: @wizard.supplierId

export default VueOptions.vue settings
